module.exports = __webpack_public_path__ + "img/shape4.7f9fddc6.svg";